// cli/src/plugins/auth.js
import axios from 'axios';

export default {
    install(app) {
        // 配置axios拦截器
        this.setupAxiosInterceptors(app);
    },

    setupAxiosInterceptors(app) {
        // 请求拦截器：自动添加JWT token
        axios.interceptors.request.use(
            (config) => {
                const token = localStorage.getItem('auth_token');
                if (token) {
                    config.headers.Authorization = `Bearer ${token}`;
                }
                return config;
            },
            (error) => Promise.reject(error),
        );

        // 响应拦截器：处理401错误
        axios.interceptors.response.use(
            (response) => response,
            (error) => {
                if (error.response?.status === 401) {
                    this.handleAuthError(app);
                }
                return Promise.reject(error);
            },
        );
    },

    handleAuthError(app) {
        // 获取user store
        const userStore = app.config.globalProperties.$pinia?.state?.value?.userstore;

        if (userStore) {
            // 通过store处理认证失败
            userStore.handleAuthError();
        } else {
            // fallback：直接处理
            localStorage.removeItem('auth_token');
            setTimeout(() => {
                if (window.location.pathname !== '/login') {
                    window.location.href = '/login';
                }
            }, 100);
        }
    },
};
